import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import isEmpty from 'lodash/isEmpty';

import { EMPLOYEE_SHOW, EMPLOYEES_LIST } from 'src/constants/EndpointUrls';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, editEmployee } from 'src/reducers/employees/employees';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { onSubmitFail } from 'jbc-front/components/FormErrors';
import { getItem, getItemErrors, setItem } from 'src/reducers/common/itemReducer';
import { concatArray } from 'src/utils/Utils';
import { defaultCommutingItem } from 'src/utils/Form';
import { detailUrlWithQueries } from 'src/utils/Http';
import { getRadioOptions } from 'src/reducers/selectOptions';
import filterSelectOption from 'src/utils/EmployeeClassificationOptions';
import { fetchEmployeeDetails } from 'src/reducers/fetchSelectOptions';

import { customEmployeeFamilySupportValidate } from './components/FamilySupportsSection';
import { validate as bussinessValidate } from './components/BusinessInfoSection';
import EmployeeEditingForm from './components/EmployeeEditingForm';
import { getTaxAmountLandmark, getTaxAmountAfterLandmark } from './inhabitantTaxCommon';
import { withTranslation } from 'react-i18next';

const validate = (values, props) => {
  const errors = Object.assign(
    {},
    ...[customEmployeeFamilySupportValidate, bussinessValidate].map((customValidate) => customValidate(values, props))
  );
  return isEmpty(errors) ? undefined : errors;
};

let EditEmployeeForm = reduxForm({
  form: EMPLOYEE_FORM,
  onSubmitFail,
  validate,
})(EmployeeEditingForm);

const mapStateToProps = (state) => {
  return {
    errors: getItemErrors(REDUCER_NAME, state),
    initialValues: {
      ...getItem(REDUCER_NAME, state),
    },
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (data) => {
    const employeeId = data.employee.id;
    dispatch(editEmployee(data, employeeId, ownProps.showEmployeeUrl));
  },
});

EditEmployeeForm = connect(mapStateToProps, mapDispatchToProps)(EditEmployeeForm);

class EditEmployee extends React.Component {
  // Format 支給・控除項目の金額設定データ
  clientUnitPriceToEmployeeUnitPrice(clientUnitPrice) {
    return {
      clientUnitPriceId: clientUnitPrice.id,
      clientUnitPriceName: clientUnitPrice.name,
      clientPayrollRulesGroupId: clientUnitPrice.clientPayrollRulesGroupId,
      useType: 'payroll_rules_group',
      amount: 0,
    };
  }

    // Format 支給・控除項目の金額設定データ
  clientAllownceToEmployeeAllowance(clientAllowance) {
    return {
      clientAllowanceId: clientAllowance.id,
      clientAllowanceName: clientAllowance.name,
      clientPayrollRulesGroupId: clientAllowance.clientPayrollRulesGroupId,
      paymentAmount: 0,
    }
  }

  pickUpCondition(employeeAllowances, blankclientAllowancesItem) {
    return !employeeAllowances.map((item) => item.clientAllowanceId).includes(blankclientAllowancesItem.clientAllowanceId)
  }

  pickUpUnitPriceCondition(employeeUnitPrices, blankclientUnitPricesItem) {
    return !employeeUnitPrices.map((item) => item.clientUnitPriceId).includes(blankclientUnitPricesItem.clientUnitPriceId)
  }

  componentWillMount() {
    const { dispatch, values } = this.props;
    dispatch(fetchEmployeeDetails());
    // Format 通勤手当データ
    const basicCommuting = ['train', 'car', 'bus'];
    const initEmployeeCommutings = values.employeeCommutings || [];
    basicCommuting.forEach((meansOfCommunication) => {
      if (!initEmployeeCommutings.find((item) => item.meansOfCommunication === meansOfCommunication)) {
        initEmployeeCommutings.push(defaultCommutingItem(meansOfCommunication));
      }
    });
    values.employeeCommutings = initEmployeeCommutings;

    const blankclientAllowancesWithId = values.clientAllowanceAmountTypeIndividual.map((item) =>
      this.clientAllownceToEmployeeAllowance(item)
    );

    const initEmployeeAllowances = concatArray(values.employeeAllowances, blankclientAllowancesWithId)(this.pickUpCondition);
    values.employeeAllowances = initEmployeeAllowances;

    const blankclientUnitPricesWithId = values.clientUnitPrices.map((item) => this.clientUnitPriceToEmployeeUnitPrice(item));

    const initEmployeeUnitPrices = concatArray(
      values.employeeUnitPrices,
      blankclientUnitPricesWithId
    )(this.pickUpUnitPriceCondition);
    values.employeeUnitPrices = initEmployeeUnitPrices;

    // Format 住民税
    // サーバから返却される月別の住民税額を簡易設定用に基準月の額とそれ以外に変換して格納する
    values.employeeInhabitantTax = {
      ...values.employeeInhabitantTax,
      taxAmountLandmark: getTaxAmountLandmark(
        values.employeeInhabitantTax.taxAmounts,
        values.employeeInhabitantTax.landmarkMonth
      ),
      taxAmountAfterLandmark: getTaxAmountAfterLandmark(
        values.employeeInhabitantTax.taxAmounts,
        values.employeeInhabitantTax.landmarkMonth
      ),
    };

    // Format ＜社会保険＞
    if (!values.employeeInsurance.employeeClassification) {
      values.employeeInsurance.employeeClassification = 'common';
    }
    const { isJoinedEmploymentInsurance, employeeClassification } = values.employeeInsurance;

    const selectOptions = filterSelectOption(isJoinedEmploymentInsurance, this.props.employeeClassifications);
    if (
      !_.isEmpty(selectOptions) &&
      !_.some(selectOptions, (item) => _.get(item, 'value') === employeeClassification)
    ) {
      values.employeeInsurance.employeeClassification = selectOptions[0].value;
    }

    dispatch(setItem(REDUCER_NAME, values));
  }

  render() {
    const { values, data } = this.props;
    const { standardYear, standardMonth } = values;
    const showEmployeeUrl = detailUrlWithQueries(
      _.get(values, 'employee.id'),
      _.get(values, 'currentQueries'),
      EMPLOYEE_SHOW
    );
    return (
      <div className="l-wrap-xl l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.staff_list')} path={EMPLOYEES_LIST} />
            <BreadCrumb.Item
              label={this.props.t('features.Employees.showEmployee.employee_information')}
              path={showEmployeeUrl}
            />
            <BreadCrumb.Item label={this.props.t('features.Employees.EditEmployee.Edit_employee_information')} />
          </BreadCrumb>
        </div>
        <EditEmployeeForm {...{ standardYear, standardMonth, showEmployeeUrl }} />
      </div>
    );
  }
}

export default withTranslation('translation')(
  connect((state) => ({
    employeeClassifications: getRadioOptions(state, 'employeeClassifications'),
    data: state,
  }))(EditEmployee)
);
